import { render } from "./InfoconnectSso.vue?vue&type=template&id=ce801b26"
import script from "./InfoconnectSso.vue?vue&type=script&lang=js"
export * from "./InfoconnectSso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__